import { render, staticRenderFns } from "./ColumnTitle.vue?vue&type=template&id=3095214d&"
import script from "./ColumnTitle.vue?vue&type=script&lang=ts&"
export * from "./ColumnTitle.vue?vue&type=script&lang=ts&"
import style0 from "./ColumnTitle.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports